import React from 'react';
import styles from './SearchBar.module.scss';
import classNames from 'classnames';

export interface SearchBarProps {
  placeholder: string;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  className?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  setSearchQuery,
  placeholder,
  className,
}) => (
  <div className={classNames(styles.searchBar, className)}>
    <input
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      type="text"
      placeholder={placeholder}
    />
  </div>
);

export default SearchBar;
